module.exports = __webpack_public_path__ + "static/img/3.27d96ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news17/3.png
// module id = vAjC
// module chunks = 1